import { Controller } from "@hotwired/stimulus"

// Лёгкий lightbox для галерей. Каждый клик по картинке открывает оверлей
// с навигацией (prev / next / ESC), counter и подписью. Прокрутка фона
// блокируется на время показа.
export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.currentIndex = 0
    this._onKey = (e) => this.handleKey(e)
  }

  disconnect() {
    this.close()
  }

  open(event) {
    event.preventDefault()
    const idx = this.itemTargets.indexOf(event.currentTarget)
    if (idx < 0) return
    this.currentIndex = idx
    this.ensureOverlay()
    this.render()
    this.overlay.classList.add("is-open")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this._onKey)
  }

  next(e) { e?.preventDefault(); e?.stopPropagation(); this.shift(1) }
  prev(e) { e?.preventDefault(); e?.stopPropagation(); this.shift(-1) }

  shift(delta) {
    const total = this.itemTargets.length
    this.currentIndex = (this.currentIndex + delta + total) % total
    this.render()
  }

  close(e) {
    e?.preventDefault()
    if (!this.overlay) return
    this.overlay.classList.remove("is-open")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this._onKey)
  }

  handleKey(e) {
    if (e.key === "Escape") this.close()
    else if (e.key === "ArrowRight") this.shift(1)
    else if (e.key === "ArrowLeft") this.shift(-1)
  }

  // ——— рендер оверлея ———

  ensureOverlay() {
    if (this.overlay) return
    const html = `
      <div class="lightbox-overlay" data-lightbox-role="overlay">
        <button class="lightbox-close" type="button" aria-label="Закрыть" data-lightbox-role="close">×</button>
        <button class="lightbox-nav lightbox-prev" type="button" aria-label="Предыдущее" data-lightbox-role="prev">‹</button>
        <figure class="lightbox-frame">
          <img alt="" data-lightbox-role="image" />
          <figcaption data-lightbox-role="caption"></figcaption>
        </figure>
        <button class="lightbox-nav lightbox-next" type="button" aria-label="Следующее" data-lightbox-role="next">›</button>
        <div class="lightbox-counter" data-lightbox-role="counter"></div>
      </div>
    `
    const div = document.createElement("div")
    div.innerHTML = html.trim()
    this.overlay = div.firstChild
    document.body.appendChild(this.overlay)

    this.imgEl = this.overlay.querySelector('[data-lightbox-role="image"]')
    this.captionEl = this.overlay.querySelector('[data-lightbox-role="caption"]')
    this.counterEl = this.overlay.querySelector('[data-lightbox-role="counter"]')

    this.overlay.addEventListener("click", (e) => {
      const role = e.target.dataset?.lightboxRole
      if (role === "overlay" || role === "close") this.close(e)
      else if (role === "prev") this.prev(e)
      else if (role === "next") this.next(e)
    })
  }

  render() {
    const item = this.itemTargets[this.currentIndex]
    if (!item) return
    const fullSrc = item.dataset.lightboxSrc || item.href || item.querySelector("img")?.src
    const caption = item.dataset.lightboxCaption || ""

    this.imgEl.src = fullSrc
    this.imgEl.alt = caption
    this.captionEl.textContent = caption
    this.captionEl.style.display = caption ? "" : "none"
    this.counterEl.textContent = `${this.currentIndex + 1} / ${this.itemTargets.length}`
  }
}
